"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ACCEPTANCE_MODE_BY_KIND = exports.AcceptanceModeSchema = exports.ACCEPTANCE_MODES = void 0;
exports.isSignatureMode = isSignatureMode;
exports.reissueRequired = reissueRequired;
const zod_1 = require("zod");
/**
 * HOW A PARTY DISCHARGES A DOCUMENT, and what a new version costs them.
 *
 * The distinction that matters is `_once` versus `_each_version`. A lease
 * somebody executed is done forever — republishing our lease template must not
 * drag a signed customer back to re-sign a contract they already performed. A
 * PCI attestation is the opposite: it asserts a present fact, so a new version
 * means a new assertion.
 *
 * Getting this wrong in either direction is expensive. Re-prompting everyone
 * trains people to click through without reading; re-prompting nobody leaves
 * the company out of compliance while its dashboard says otherwise.
 */
exports.ACCEPTANCE_MODES = [
    'acknowledge_once', 'acknowledge_each_version', 'sign_once', 'sign_each_version',
];
exports.AcceptanceModeSchema = zod_1.z.enum(exports.ACCEPTANCE_MODES);
/**
 * The default a binding inherits when it names no mode.
 *
 * A policy is accepted and an agreement is signed — that is the existing rule
 * throughout the engine, and these defaults keep it true without an operator
 * having to think about it. `acknowledge_each_version` for policies because a
 * privacy policy or terms of service is a live statement, not a historical act.
 */
exports.DEFAULT_ACCEPTANCE_MODE_BY_KIND = {
    policy: 'acknowledge_each_version',
    agreement: 'sign_once',
};
function isSignatureMode(mode) {
    return mode === 'sign_once' || mode === 'sign_each_version';
}
/**
 * Does publishing `changeType` oblige a party who already discharged this
 * document to act again?
 *
 * A MINOR publish never obliges anybody. That is the whole point of the
 * distinction: a typo fix must be free. Only `_each_version` modes react, and
 * only to `material`.
 */
function reissueRequired(mode, changeType) {
    if (changeType !== 'material')
        return false;
    return mode === 'acknowledge_each_version' || mode === 'sign_each_version';
}
//# sourceMappingURL=documentAcceptanceModes.js.map